import { get } from "lodash";
import React, { FC, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { Col } from "reactstrap";
import PromptModal from "src/components/ConfirmationModal/PromptModalV2";
import { ITableColumn } from "src/components/FinalTable/FinalTable";
import * as S from "src/constants/StringConstants";
import { ICommissionHistory } from "src/store/models/document.model";
import { fetchBrokerCommissionLogs } from "src/store/reducers/brokerCommissions";
import DisTable from "../../../components/TableV2/Table";
import { formatDate } from "../../CampaignDetail/utils";

interface CommissionHistoryModalProps {
  open: boolean;
  onClose: () => void;
  brokerId: string;
  commissionId: number | null;
  widthRem?: number;
}

const CommissionHistoryModal: FC<CommissionHistoryModalProps> = ({
  open,
  onClose,
  brokerId,
  commissionId,
  widthRem = 64,
}) => {
  const tableRef = useRef<any>(null);
  const dispatch = useDispatch();

  const columns: ITableColumn<ICommissionHistory>[] = [
    {
      key: "modifiedDate",
      title: S.BRO_COMMISSIONS_MODIFIED_DATE,
      style: { textAlign: "left" },
      render: r => formatDate(r.modifiedDate),
    },
    // { key: "modifiedBy", title: S.BRO_COMMISSIONS_MODIFIED_BY, style: { textAlign: "left" } },
    {
      key: "previousOverridePercentage",
      title: S.BRO_COMMISSIONS_PREVIOUS_OVERRIDE,
      style: { textAlign: "left" },
      render: r => `${r.previousOverridePercentage} %`,
    },
    {
      key: "currentOverridePercentage",
      title: S.BRO_COMMISSIONS_UPDATED_OVERRIDE,
      style: { textAlign: "left" },
      render: r => `${r.currentOverridePercentage} %`,
    },
  ];

  useEffect(() => {
    if (open && commissionId != null) {
      tableRef.current?.update?.();
    }
  }, [open, commissionId]);

  return (
    <PromptModal title={"Commission History"} open={open} rejectText="Close" onReject={onClose}>
      <Col className="doc-tab__table-override">
        <DisTable<ICommissionHistory>
          columns={columns}
          isPaginated={false}
          initialState={{}}
          getRef={ft => (tableRef.current = ft)}
          onUpdate={async () => {
            if (!open || commissionId == null) {
              return { total: 0, data: [] as ICommissionHistory[] };
            }

            const result = await dispatch(fetchBrokerCommissionLogs(brokerId, commissionId));
            const data = (get(result, "value.data") || []) as ICommissionHistory[];

            return { total: data.length, data };
          }}
        />
      </Col>
    </PromptModal>
  );
};

export default CommissionHistoryModal;
